import { SettingsMimetypesService } from "../client"

/* Interfaces */
export interface AddSettingsMimeTypeProps {
    onClose: () => void
    isOpen: boolean
}


/* Endpoints */
export const readSettingsMimetypes = () => {
    return {
        queryFn: async () => {
            const data = SettingsMimetypesService.readSettingsMimetypes()

            return data ?? { data: null, count: 0 }
        },
        queryKey: ["settings-mimetypes"],
    }
}
